import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';

const getTenantClassName = () => `tenant--${GDPRConfig.locale.toLowerCase().replace('-', '')}`;

export default getTenantClassName;
